// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g3RzuQmsvyPX56 {
  display: block;
  position: relative;
  flex: 1 0 22%;
  max-width: 23.5%;
  height: 96px;
  margin-right: 2%;
  margin-bottom: 2%;
  border-radius: 3px;
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  background-position: center center;
  background-size: cover;
  color: #ffffff;
  text-decoration: none;
}
.g3RzuQmsvyPX56:nth-of-type(4n) {
  margin-right: 0;
}
@media only screen and (min-width: 751px) and (max-width: 900px) {
  .g3RzuQmsvyPX56 {
    flex: 1 0 31%;
    max-width: 32%;
  }
  .g3RzuQmsvyPX56:nth-of-type(4n) {
    margin-right: 2%;
  }
  .g3RzuQmsvyPX56:nth-of-type(3n) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 750px), only screen and (max-width: 450px) {
  .g3RzuQmsvyPX56 {
    flex: 1 0 48%;
    max-width: 49%;
  }
  .g3RzuQmsvyPX56:nth-of-type(3n) {
    margin-right: 2%;
  }
  .g3RzuQmsvyPX56:nth-of-type(2n) {
    margin-right: 0;
  }
}
.TeuVsz8bhf3hsk {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 3px;
  background-color: hsla(0, 0%, 0%, 0.15);
}
.g3RzuQmsvyPX56:hover {
  color: #ffffff;
  text-decoration: none;
}
.g3RzuQmsvyPX56:hover .TeuVsz8bhf3hsk {
  background-color: hsla(0, 0%, 0%, 0.25);
}
.qrelFBps7MQWSh {
  display: flex;
  position: relative;
  flex-direction: column;
  height: 80px;
  padding: 8px;
}
.zkdDoKSzgAVnL2 {
  position: relative;
  margin: 2px 0 0 0;
  color: #ffffff;
  font-size: 16px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 20px;
}
.C1FLdWBgnOZJ9M {
  flex: 1 0 22%;
  max-width: 23.5%;
  margin-right: 2%;
  margin-bottom: 2%;
}
.C1FLdWBgnOZJ9M:nth-of-type(4n) {
  margin-right: 0;
}
@media only screen and (min-width: 751px) and (max-width: 900px) {
  .C1FLdWBgnOZJ9M {
    flex: 1 0 31%;
    max-width: 32%;
  }
  .C1FLdWBgnOZJ9M:nth-of-type(4n) {
    margin-right: 2%;
  }
  .C1FLdWBgnOZJ9M:nth-of-type(3n) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 750px), only screen and (max-width: 450px) {
  .C1FLdWBgnOZJ9M {
    flex: 1 0 48%;
    max-width: 49%;
  }
  .C1FLdWBgnOZJ9M:nth-of-type(3n) {
    margin-right: 2%;
  }
  .C1FLdWBgnOZJ9M:nth-of-type(2n) {
    margin-right: 0;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"templateTile": `g3RzuQmsvyPX56`,
	"templateTileFade": `TeuVsz8bhf3hsk`,
	"templateTileDetails": `qrelFBps7MQWSh`,
	"templateTitle": `zkdDoKSzgAVnL2`,
	"newTemplateTile": `C1FLdWBgnOZJ9M`
};
export default ___CSS_LOADER_EXPORT___;
